/* Hamper bundle guard. Removes the hamper box when it is in the cart without its builder
   items, or when a built hamper is incomplete. Keys on the SKU (the product title changed
   on 22 Oct 2026, the SKU did not) and on the hidden bundle id. Counts units, so a hamper
   with two of one item (one line, quantity 2) is complete. Re-reads /cart.js on load and
   after every cart change, because add-to-cart events do not carry the full cart.
   Reloads only after a successful update, and at most once per cart state, so a failing
   cart API cannot loop the page. */
(function () {
  var HAMPER_SKU = 'SHARK-TANK-HAMPER';
  var BUNDLE_ID = 'shark-tank-hamper';
  var ITEMS_PER_HAMPER = 4;
  var running = false;

  function check(cart) {
    if (running || !cart || !cart.items || !cart.items.length) return;
    var hamperUnits = 0, itemUnits = 0, bundleLines = [], orphans = [];
    cart.items.forEach(function (item) {
      var inBundle = !!(item.properties && item.properties._byob_bundle === BUNDLE_ID);
      if (item.sku === HAMPER_SKU) {
        if (inBundle) { hamperUnits += item.quantity; bundleLines.push(item); }
        else { orphans.push(item); }
      } else if (inBundle) {
        itemUnits += item.quantity; bundleLines.push(item);
      }
    });
    var updates = {};
    orphans.forEach(function (item) { updates[item.key] = 0; });
    if (bundleLines.length && (hamperUnits === 0 || itemUnits < ITEMS_PER_HAMPER * hamperUnits)) {
      bundleLines.forEach(function (item) { updates[item.key] = 0; });
    }
    if (!Object.keys(updates).length) {
      try { sessionStorage.removeItem('ew_byob_guard_sig'); } catch (e) {}
      return;
    }
    var sig = Object.keys(updates).sort().join('|');
    try { if (sessionStorage.getItem('ew_byob_guard_sig') === sig) return; } catch (e) {}
    running = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      if (r.ok) {
        try { sessionStorage.setItem('ew_byob_guard_sig', sig); } catch (e) {}
        window.location.reload();
      } else { running = false; }
    }).catch(function () { running = false; });
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(check)
      .catch(function () {});
  }

  function init() {
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
    document.addEventListener('cart:added', refresh);
    if ('requestIdleCallback' in window) requestIdleCallback(refresh); else setTimeout(refresh, 1500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
